export default __webpack_public_path__ + "static/media/bloodshroud.9355208c.png";